$(function () {
  let $accordions = $('.accordion');
  $accordions.each(function () {
    let $accordion = $(this);
    let $triggers = $accordion.find('.accordion__title');

    $triggers.each(init);
    $triggers.on('click keydown', toggle);

    function init() {
      let $trigger = $(this);
      let $item = $trigger.closest('.accordion__item');
      let $content = $item.find('.accordion__content');
      let _id = ID();

      $trigger.attr('id', `trigger${_id}`);
      $trigger.attr('aria-controls', `content${_id}`);
      $trigger.attr('aria-expanded', false);

      $content.attr('id', `content${_id}`);
      $content.attr('aria-labelledby', `trigger${_id}`);
      $content.hide();

			$accordion.addClass("accordion--initialized");

      function ID() {
        return '_' + Math.random().toString(36).substr(2, 9);
      }
    }

    function toggle(e) {
      const event = e.originalEvent || false;
      if (event) {
        if (event instanceof KeyboardEvent) {
          if (event.code !== 'Enter' && event.code !== 'Space') return;
        }
        e.preventDefault();
      }

      let $trigger = $(this);
      let $item = $trigger.closest('.accordion__item');
      let $content = $item.find('.accordion__content');

      if (event && $accordion.hasClass('accordion--single')) {
        let $siblings = $triggers.filter(function () {
          return (
            $(this)[0] !== $trigger[0] &&
            $(this).closest('.accordion__item').hasClass('is-open')
          );
        });
        $siblings.each(toggle);
      }

      if ($item.hasClass('is-open')) {
        $item.removeClass('is-open');
        $trigger.attr('aria-expanded', false);
        $content.slideUp();
      } else {
        $item.addClass('is-open');
        $trigger.attr('aria-expanded', true);
        $content.slideDown();
      }
    }
  });
});
